// modal-basic.js
(() => {
  const OPEN_ATTR  = "data-open";   // ej: <button data-open="#modalLogin">
  const CLOSE_ATTR = "data-close";  // ej: <button data-close>
  const MODAL_ATTR = "data-modal";  // ej: <section id="modalLogin" data-modal>

  let lastFocused = null;

  // Cierra todos los modales
  const closeAll = () => {
    document.querySelectorAll(`[${MODAL_ATTR}]`).forEach(m => {
      m.style.display = "none";
      m.setAttribute("aria-hidden", "true");
    });
    document.body.style.overflow = ""; // opcional: desbloquear scroll
  };

  // Abre el modal de un selector (#id)
  const openBySelector = (selector) => {
    if (!selector) return;
    const modal = document.querySelector(selector);
    if (!modal) return;

    lastFocused = document.activeElement;
    closeAll();

    // accesibilidad básica
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.removeAttribute("aria-hidden");

    // mostrar
    modal.style.display = "flex";
    document.body.style.overflow = "hidden"; // opcional: bloquear scroll detrás

    // focus al primer foco o al modal
    const focusable = modal.querySelector(
      'a[href], button:not([disabled]), textarea:not([disabled]), input:not([type="hidden"]):not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    (focusable || modal).focus?.();
  };

  // Delegación: abrir/cerrar
  document.addEventListener("click", (e) => {
    const openBtn = e.target.closest(`[${OPEN_ATTR}]`);
    if (openBtn) {
      e.preventDefault();
      const target = openBtn.getAttribute(OPEN_ATTR);
      openBySelector(target);
      return;
    }

    // cerrar por botón con data-close
    const closeBtn = e.target.closest(`[${CLOSE_ATTR}]`);
    if (closeBtn) {
      e.preventDefault();
      closeAll();
      lastFocused?.focus?.();
      return;
    }

    // cerrar por clic fuera del contenido interno
    const opened = [...document.querySelectorAll(`[${MODAL_ATTR}]`)]
      .find(m => m.style.display === "flex");
    if (opened) {
      const content = opened.querySelector("[data-modal-content]") || opened.firstElementChild;
      if (content && !content.contains(e.target)) {
        closeAll();
        lastFocused?.focus?.();
      }
    }
  });

  // cerrar con Esc
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      const opened = [...document.querySelectorAll(`[${MODAL_ATTR}]`)]
        .some(m => m.style.display === "flex");
      if (opened) {
        e.preventDefault();
        closeAll();
        lastFocused?.focus?.();
      }
    }
  });

  // API mínima por si quieres abrir/cerrar desde otros scripts
  window.Modals = {
    open: openBySelector,
    closeAll,
  };
})();
